/* Sticky collection filter sits below the stuck header (#54). */
(function () {
  function place() {
    var filter = document.querySelector('.collection-filter');
    if (!filter) return;

    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (!mobile) {
      if (filter.dataset.leveretFilterTop === '1') {
        filter.style.top = '';
        delete filter.dataset.leveretFilterTop;
      }
      return;
    }

    var stuck = document.querySelector('.site-header--stuck');
    var top = 0;
    if (stuck) {
      var height = Math.round(stuck.getBoundingClientRect().height);
      if (height > 0) top = height;
    }
    filter.style.top = top + 'px';
    filter.dataset.leveretFilterTop = '1';
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  function boot() {
    place();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      schedule();
      window.setTimeout(schedule, 600);
    });
    document.addEventListener('collection:reloaded', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
